module.exports = __webpack_public_path__ + "static/media/container_icon.2cc66363.svg";